export default function Logo({ className = "h-8 w-8", alt = "ChatEPC" }) {
  return (
    <img
      src="/logo.png"
      alt={alt}
      className={`${className} object-contain select-none`}
      draggable={false}
    />
  );
}
